exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".swal2-popup {\n  margin-top: 10vh !important; }\n", ""]);

